import { useCallback, useMemo, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { NewsMetricsDataType } from "../../types";
import { newsMetricsDataTypeTranslationKeyMap } from "../../utils/translationKeysConfig";

const TABS: NewsMetricsDataType[] = ["stories", "pressReleases", "mentions"];

export const useTabs = () => {
    const { translate } = useTranslate();
    const [tabIndex, setTabIndex] = useState(0);

    const onSelect = useCallback((index: number) => setTabIndex(index), []);

    const tabs = useMemo(
        () =>
            TABS.map((tab) => ({
                id: tab,
                label: translate(newsMetricsDataTypeTranslationKeyMap[tab]),
                dataAutomation: tab !== "pressReleases" ? `${tab}-tab` : `press-releases-tab`,
            })),
        [translate],
    );

    return {
        selectedDataType: TABS[tabIndex],
        tabs,
        tabIndex,
        onSelect,
    };
};
